module.exports = __webpack_public_path__ + "static/media/4 POINT 14 TONEARM.7a721993.png";